import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';

declare var $;

@Component({
  selector: 'itpx-inner-course-card',
  templateUrl: './inner-course-card.component.html',
  styleUrls: ['./inner-course-card.component.css', '../../style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InnerCourseCardComponent implements OnInit {
  @Input() conf: CardConfiguration;
  @Input() platformClass: any;
  private tagType: string;
  private expired: boolean;
  private supplements: string;
  private imageWidth: string;
  private imageHeight: string;
  private cardHeight: string;
  private cardWidth: string;
  private thumbnail: string;
  private readonly dateFormat: string = 'mediumDate'; //'d-MM-yyyy';

  constructor() { }

  ngOnInit() {
    Object.assign(this, this.conf);
    this.supplements = this.platformClass.productVariant && this.platformClass.productVariant.supplements ?
      this.platformClass.productVariant.supplements.join() : '';
    
  }


}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/common/banner-card/inner-course-card/inner-course-card.component.ts